import { FC, memo, ReactNode } from 'react';

import './CustomTimeGutter.scss';
import { ZoneLabelTimeline } from '../../Circadian';
import { HOUR_BLOCK_HEIGHT } from '../constants';
import { PeakDipStartEndSet } from '../../../../data-access';

interface CustomTimeGutterProps {
  peaksDipsBoundaries?: PeakDipStartEndSet;
  children: ReactNode;
  disabled?: boolean;
}

const calendarHeight = 24 * HOUR_BLOCK_HEIGHT;

const CustomTimeGutter: FC<CustomTimeGutterProps> = memo(
  ({ peaksDipsBoundaries, children, disabled = false }) => {
    return (
      <div className="custom-time-gutter" style={{ height: `${calendarHeight}px` }}>
        {peaksDipsBoundaries && (
          <ZoneLabelTimeline
            peaksDipsBoundaries={peaksDipsBoundaries}
            className="custom-time-gutter__zone-labels"
            disabled={disabled}
          />
        )}
        {children}
      </div>
    );
  }
);

export default CustomTimeGutter;
